import { render, staticRenderFns } from "./HeadersTable.vue?vue&type=template&id=4977888d&scoped=true&"
import script from "./HeadersTable.vue?vue&type=script&lang=ts&"
export * from "./HeadersTable.vue?vue&type=script&lang=ts&"
import style0 from "./HeadersTable.vue?vue&type=style&index=0&id=4977888d&scoped=true&lang=css&"
import style1 from "./HeadersTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977888d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
